var name = "Scarlet 201_2B4Pv1";
var uuid = "9aebd2b9-6be0-46e8-967d-9eee0e0af449";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	11.675,
	3.045,
	7.775
];
var anchor = [
	0.5,
	0,
	1
];
var color = "#00965e";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "bf9d682f-87a3-4eb4-b240-f8332d202d85",
		pos: [
			-5.5625,
			0.145,
			-7.775
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			7.225,
			0.16,
			1.5
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "a4835cda-7809-4bd9-a555-a867397932bd",
				pos: [
					3.6125,
					0.08,
					0.75
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					7.225,
					0.16,
					1.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Double 2",
		uuid: "9939218f-76e3-41b4-8dac-aea0c18f3d91",
		pos: [
			-3.9,
			0.305,
			-4.135
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "M4(2) Bathroom",
		uuid: "52111c88-26de-4c44-8c16-0be770fb43e9",
		pos: [
			-4.7,
			0.305,
			-1.2375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			2.2,
			2.4384,
			2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "dc68e2f5-5e89-4ee1-8cba-bf3c6a9df50b",
		pos: [
			3.9,
			0.305,
			-3.7375
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			7.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining"
		}
	},
	{
		name: "Storage",
		uuid: "2b72b7f6-8eb4-48b0-b59d-a2baf61180cc",
		pos: [
			0.8475,
			0.305,
			-0.5375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.905,
			2.4384,
			0.8
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Utility",
		uuid: "5f755f78-3238-475e-9dca-8e0d79793457",
		pos: [
			-1,
			0.305,
			-0.5375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.6
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Hallway",
		uuid: "834da0b4-7c8d-4530-8cb0-f810760c1fc7",
		pos: [
			-0.8212,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			5.5675,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					-3.605,
					0.305,
					-0.1375
				],
				[
					-2.1,
					0.305,
					-0.1375
				],
				[
					-2.1,
					0.305,
					-1.2375
				],
				[
					-1.8,
					0.305,
					-1.2375
				],
				[
					-1.8,
					0.305,
					-1.0325
				],
				[
					-0.1525,
					0.305,
					-1.0325
				],
				[
					1.8,
					0.305,
					-1.0325
				],
				[
					1.8,
					0.305,
					-1.2375
				],
				[
					1.9625,
					0.305,
					-1.2375
				],
				[
					1.9625,
					0.305,
					-2.3375
				],
				[
					1.7984,
					0.305,
					-2.3375
				],
				[
					-1.7984,
					0.305,
					-2.3375
				],
				[
					-1.8,
					0.305,
					-2.3375
				],
				[
					-2.1,
					0.305,
					-2.3375
				],
				[
					-2.1016,
					0.305,
					-2.3375
				],
				[
					-3.605,
					0.305,
					-2.3375
				],
				[
					-3.605,
					0.305,
					-0.1375
				]
			]
		}
	},
	{
		name: "Bedroom Double 1",
		uuid: "1c0cd554-c4dd-4330-87c1-66118108ea1c",
		pos: [
			0,
			0.305,
			-4.135
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "module",
		uuid: "d5aea3b2-29f9-4154-a6b0-01c22c3e4133",
		pos: [
			-3.9,
			1.5225,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#00965e",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "e4949e5f-4223-4602-88e2-cc03418a5b4b",
				pos: [
					0,
					0.0725,
					-2.9187
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "3678a0eb-febd-4165-885b-cc90eb61b9e7",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "7d0e3c86-1457-4e24-96ce-cebb64eec9e0",
				pos: [
					-1.8687,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "005c8863-a06d-4967-b047-6b2a7c8358c9",
				pos: [
					-0.0688,
					0.0725,
					2.9188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "b1f711a3-f149-4312-8312-6b34016918c8",
						pos: [
							-1.1638,
							-0.2275,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "6d2b5ad1-78cd-42aa-b7a4-124c12a60177",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "a12908e6-f6b5-42f1-b773-60c0bb7b406e",
						pos: [
							-1.25,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "152ae508-a796-4831-922b-5de254835d6a",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "31e4de77-3a3c-40e3-8b04-76b5e49e8c5c",
				pos: [
					0.2475,
					0.07,
					1.75
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					2.2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "91aedc19-b8cd-44a3-ab09-fa3dfece224b",
						pos: [
							-0.5,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "828ecc6c-40e6-447b-86c9-b9236ec7a214",
				pos: [
					0,
					0.07,
					0.6025
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "745913c8-bc07-44ba-92aa-6f503360e3da",
						pos: [
							-1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "e46f78a1-87a5-41dc-9883-c46956a36922",
				pos: [
					0.0688,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.7375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "4252edf4-23c0-487e-b441-3618a478ab13",
				pos: [
					0,
					-1.4075,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "4ad8592d-34ac-4142-a3a0-09097e9eb712",
				pos: [
					0,
					-1.4075,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d45a52ab-f2ee-471e-bd0d-ad1f96b179a7",
				pos: [
					0,
					-1.372,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "610c46b8-19a0-4d24-b0a5-622634eb24db",
				pos: [
					0,
					-1.372,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "87e4fb48-1c05-4235-a661-4ace05ab253a",
				pos: [
					0,
					-1.372,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7df9a867-f173-49a8-ab3e-47ea27756d2a",
				pos: [
					0,
					-1.372,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "264aa0fa-06bb-409f-b358-1c98b49ea626",
				pos: [
					0,
					-1.3595,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "08eef83f-27a1-4802-9b1e-ee318778095e",
				pos: [
					0,
					-1.3595,
					0.0563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b3977b07-0c5e-41d7-8f44-954a82bcc0f6",
				pos: [
					0,
					-1.3595,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "adb4aca4-9749-456b-9fc3-216d8e37900c",
				pos: [
					0,
					-1.3595,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d0b7d5af-ced0-48ab-811f-f624e697a436",
				pos: [
					0,
					-1.3595,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7f933fef-00be-452f-86d3-730195ec53a5",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "93774f90-95e5-4bb7-8e80-fadaa0e7d73e",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "dc78cbb7-2005-4fc6-92e0-863ba7f9e537",
				pos: [
					-1.875,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "63f64b4d-2579-4740-aef5-3d675b382546",
				pos: [
					-1.875,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "f32a5c0a-38d3-449b-990c-47211bce5856",
				pos: [
					1.875,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "d153c959-334e-45a5-a209-2342377ccee7",
				pos: [
					1.875,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "1fe1d519-e98c-4200-8f18-daebe8d2b3c6",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "b7247bc7-7048-48f7-b509-7b1595f06196",
		pos: [
			0,
			1.5225,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#00965e",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "ae7da6a5-88ec-4490-a400-9f353fdbcd7b",
				pos: [
					0,
					0.0725,
					-2.9187
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "d17ee60f-e7f8-4833-b26a-a11acfd2027e",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "871b5e9a-c821-4a75-8dd6-f0d50d36c61c",
				pos: [
					-1.8687,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "2c921946-a284-4008-b727-2da28563f5d9",
						pos: [
							1.3188,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "369cd520-53d3-404b-998c-88b7906ab27e",
				pos: [
					-0.0687,
					0.0725,
					2.9188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "fcffe8dc-8d5e-4bde-a7b0-64db8a419bdd",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "592e9836-9b36-448a-b3fc-1a1743d55361",
						pos: [
							-1.25,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "904d7c62-d4d0-48ef-a060-1eda2aeaabeb",
				pos: [
					0,
					0.07,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "be9cea51-b0ac-4409-8d78-de6ab3f17318",
						pos: [
							-1,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "881a37b5-85db-4dc6-8dfe-f3806116da90",
						pos: [
							0.875,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "b869e27e-1882-4691-b784-27e858621385",
				pos: [
					-0.1525,
					0.07,
					2.45
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.8,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e643691c-63c1-45de-9a56-9e97f85d1ae8",
				pos: [
					0,
					0.07,
					0.6025
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "ca8dd3f2-37c0-4262-bde5-33f2903aba68",
						pos: [
							-1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "01986ed9-c32d-4e8b-bbb4-31adc9b5c475",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "fea6acf5-ea0f-4190-8e89-afb9543d8e87",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.875
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "aad70c5b-0e40-4ee8-9633-d8c37488e0cf",
				pos: [
					0,
					-1.4075,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9ebdb5c3-74a1-48a6-8775-a97f1589de4c",
				pos: [
					0,
					-1.4075,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "09f61d65-d2fb-49b9-96a4-4cb034dcacd4",
				pos: [
					0,
					-1.372,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "4804be9b-3197-408f-88fb-4aba077b14fc",
				pos: [
					0,
					-1.372,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e4444c51-137e-436f-ac23-1b21863a6d91",
				pos: [
					0,
					-1.372,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7a9da46b-4b97-4c27-9e5f-2f9612fd6b2a",
				pos: [
					0,
					-1.372,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9367a8ab-a7d5-4825-b724-cfa9ca53aae1",
				pos: [
					0,
					-1.3595,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "4af61953-d93d-4de5-8bb8-2c3fb6b40c8c",
				pos: [
					0,
					-1.3595,
					0.0563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "dcc31fb6-160e-4261-a99e-d05736cf33d9",
				pos: [
					0,
					-1.3595,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "317518c2-5470-4a81-a8d9-0735bfcf0f08",
				pos: [
					0,
					-1.3595,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "713a6eb7-b9c8-4016-ae8f-f7f6ae36a3fa",
				pos: [
					0,
					-1.3595,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "78c8e4f6-6fe2-44d6-a50e-54f7e5f011b9",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "583baedd-5810-4d6b-a33e-f6d657776d9f",
				pos: [
					1.875,
					-1.4075,
					0.0145
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.789,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "fc87b753-f61c-4576-9c17-a8ca81b4121b",
				pos: [
					-1.875,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "f4d88cef-7fc4-419f-9cad-647a0650db28",
				pos: [
					-1.875,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "77a29c96-29c8-44cf-8f03-470ca88b5bf8",
				pos: [
					1.875,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "11ed113d-977d-4774-8669-fcf4d14d64ad",
				pos: [
					1.875,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "68a4d944-0ac6-4f02-9e1d-29e6d0ee7696",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "6d59fc90-cc6f-43dc-8dd4-14d2081aa280",
		pos: [
			3.9,
			1.5225,
			-3.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			7.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#00965e",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "f0324401-8f52-4a31-80cf-9cd06df916af",
				pos: [
					0,
					0.0725,
					-3.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "720eeb14-faf9-4316-9814-af2ca774bb8b",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f6e3892f-d886-4564-a290-0e0cb5e49a96",
				pos: [
					-1.8687,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "80f4e04f-03ce-44ea-bda6-7ae6c8b7c4af",
						pos: [
							2.0688,
							-0.227,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "11ce73df-efda-4e44-a6ca-2d339cf2ce89",
				pos: [
					-0.0688,
					0.0725,
					3.6688
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "a0d2a6d8-d294-4dc7-86f9-9bc11f2da150",
				pos: [
					1.8688,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "758c0e08-4d27-4ea5-9b5f-8e92a6f33320",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "9d77776f-6f4d-441c-b42e-220557913e46",
				pos: [
					-0.0688,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.01,
					3.7375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "203d5140-62e7-4aec-9f3a-b7464b32f60a",
				pos: [
					0,
					-1.4075,
					-3.6738
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "3b61410a-05fa-43a8-bee3-de79cdf7c018",
				pos: [
					0,
					-1.4075,
					3.6763
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9794d932-8eb1-4155-adcc-473c36c94160",
				pos: [
					0,
					-1.372,
					-3.3
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ea8579d0-d79c-4772-90cd-c5ac32f16585",
				pos: [
					0,
					-1.372,
					-3.5475
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "24fa455b-b324-4530-9e8e-ed4b46f7e7a0",
				pos: [
					0,
					-1.372,
					3.55
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e4b001cd-9973-4e6d-a039-b79d1807501f",
				pos: [
					0,
					-1.372,
					3.3025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "813b0c5a-26da-4780-8472-2a4d4a1f88fb",
				pos: [
					0,
					-1.3595,
					0.8063
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "29a5bf7c-d87b-4902-9301-3e55ba5f3918",
				pos: [
					0,
					-1.3595,
					0.7463
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d119a29f-bd0d-4a49-b8c6-6fbb812b0161",
				pos: [
					0,
					-1.3595,
					2.1063
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "240e7280-ddf3-424b-9b08-5ed9dcd6b1b8",
				pos: [
					0,
					-1.3595,
					2.0463
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e88f60fa-8135-42ab-be9a-c6e29dbea019",
				pos: [
					-1.875,
					-1.4075,
					0.0012
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9693f5af-1e0e-4a86-a637-8fd8774b57cc",
				pos: [
					1.875,
					-1.4075,
					0.0012
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "cb4b5425-824f-4895-b7f1-a1409fc904b4",
				pos: [
					-1.875,
					0.0812,
					3.4263
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "7acda09d-2da3-4751-9cb5-6cb6963eafb6",
				pos: [
					-1.875,
					0.0812,
					-3.4238
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "952a4871-a596-4c96-9b51-4b6c58eae3f1",
				pos: [
					1.875,
					0.0812,
					3.4263
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "17dc7b51-6930-4026-ac04-8bcf29817984",
				pos: [
					1.875,
					0.0812,
					-3.4238
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "eaceb75c-515d-48e5-a9bb-f77d4881ea71",
				pos: [
					0,
					-1.372,
					-0.6
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "264b6c51-4b96-4d70-a956-b9270293e102",
				pos: [
					0,
					-1.372,
					-0.8475
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "1345b5e3-2743-4852-850a-99d6fca41d96",
				pos: [
					-1.875,
					0.0812,
					-0.7237
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "b7ee499d-fe40-41eb-9081-80c8be721041",
				pos: [
					1.875,
					0.0812,
					-0.7237
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "3a93ef19-ec65-4ac4-8862-37088a55a52a",
				pos: [
					0,
					-1.3595,
					-2.0337
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "cfda6e61-f041-4ed9-9c25-5f0d3b7e821a",
				pos: [
					0,
					-1.3595,
					-2.0937
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "ceiling",
				uuid: "4390ead8-b83e-41ba-835a-1112870c27e6",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 4,
	bedrooms: 2,
	habitableRooms: 3,
	nia: 70.38,
	muscleID: "",
	category: "2B4P",
	aboveEntrance: true
};
var UK01_2B4P_V1 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK01_2B4P_V1 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=Scarlet-201-2B4Pv1.json.js.map
